// apps/client/src/net/handlers/museum.ts (M2-T10) — the museum snapshot on entering, and `museum.donated` (anyone's donation, yours
// included) into the hall state and, when you are inside, the hall and tanks.
import { t } from '@whiskerton/content';
import { useGame } from '../../state/store';
import { refreshMuseum } from '../../world/spaces/museum';
import type { NetHandlers } from '../../game/game';

export const handlers: NetHandlers = {
  onSpace(space) { if (space.kind === 'museum') useGame.getState().museumSetState(space.museum); },
  events: {
    'museum.donated': (e, game) => {
      useGame.getState().museumAddEntry(e.kind, e.entry);
      // G12: a completed hall is the whole town's milestone; the donor's own toast comes with their donate ack (state/slices/museum.ts).
      const me = useGame.getState().you?.resident;
      if (e.hallComplete && e.entry.donor.id !== me) {
        useGame.getState().toast('museum.hallCompleteToast', { hall: t(e.hallComplete === 'fossils' ? 'curator.hallFossilsName' : 'curator.hallFishName') });
      }
      const s = useGame.getState().museumState;
      if (s) refreshMuseum(game, s);
    },
  },
};
